import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneNodeItem is of dataType "chart"
 */
export function isSceneChartNode(node: SceneNodeItem): node is SceneNodeItem<"chart"> {
  return node.dataType === "chart";
}

export function isChartTreeNode(treeNode: SceneTreeNode): treeNode is SceneTreeNode<"chart"> {
  return treeNode.node.dataType === "chart";
}
